<template>
  <article class="" v-if="charged">
    <section class="trainers__header">
      <div class="trainers__header--title">
        <p style="width:100%">Crear lugar de entrenamiento</p>
        <v-breadcrumbs style="width: 100%">
          <v-icon slot="divider">chevron_right</v-icon>
          <v-breadcrumbs-item
            @click="$router.push({name: 'access'})">
            Resumen locaciones
          </v-breadcrumbs-item>
          <v-breadcrumbs-item
            @click="$router.push({name: 'location_access', params: {id: originalLocation.id}})">
            {{originalLocation.name}}
          </v-breadcrumbs-item>
          <v-breadcrumbs-item
            disabled>
            {{sublocation.attributes.name.length>0?sublocation.attributes.name:"Crear lugar de entrenamiento"}}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </div>
    </section>
    <section class="trainers__create_container data_card__headers--days--panel">
      <v-layout row wrap>
        <v-flex xs12 style="display:flex">
          <v-flex xs5>
            <span class="data_card__info--label">Seleccionar sede</span>
            <v-select
              label="Seleccionar sede"
              :items="locations"
              style="margin-top:20px"
              item-value="id"
              item-text="name"
              v-model="sublocation.attributes.location_id"
              single-line
              dense
              solo
              color = "blue bold"
            ></v-select>
          </v-flex>
          <v-flex xs1>
          </v-flex>
          <v-flex xs6>
            <span class="data_card__info--label" style="white-space: nowrap;">Nombre del lugar de entrenamiento</span>
            <input
              class="data_card__info--input--number"
              style="margin-top:18px; height:50px"
              type="text"
              name="Name"
              placeholder="Nombre de la locación"
              v-model="sublocation.attributes.name">
          </v-flex>
        </v-flex>
        <!-- <v-flex xs12 style="display:flex">
          <v-flex xs5>
            <span class="data_card__info--label" style="white-space: nowrap;">Correo</span>
            <input
              class="data_card__info--input--number"
              style="margin-top:18px; height:50px"
              type="text"
              name="Email"
              placeholder="Correo electrónico"
              v-model="sublocation.attributes.email">
          </v-flex>
          <v-flex xs1>
          </v-flex>
          <v-flex xs6>
            <span class="data_card__info--label" style="white-space: nowrap;">Celular</span>
            <input
              class="data_card__info--input--number"
              style="margin-top:18px; height:50px"
              type="text"
              name="Mobile"
              placeholder="Número de teléfono celular"
              v-model="sublocation.attributes.mobile">
          </v-flex>
        </v-flex> -->
      </v-layout>
    </section>
    <v-flex xs12 style="display:flex;margin-top:50px;justify-content:left">
      <v-flex xs4 style="margin-top:20px">
        <h6 class="text_title" style="white-space: nowrap;"><b>Selecciona tus horarios</b></h6>
      </v-flex>
      <v-flex xs8 style="margin-left:20px">
        <div
          class="data_card__create_button--info" style="width:90%">

          <v-flex xs4> {{days[actual_day].name_esp}} </v-flex>
          <v-flex xs2></v-flex>
          <v-flex xs5> <b>{{days[actual_day].max_spaces}} / {{maximum_spaces[actual_day]}} cupos </b></v-flex>

        </div>
      </v-flex>
    </v-flex>


    <v-flex
      xs12
      style="display:flex; margin: 50px 3% 0px 3%;">
        <v-layout
            row wrap justify-space-between>
          <v-flex  v-for="day in days"
            :key="day.name"
            v-if="day.name!='sunday'||isWeekendActive"
            class="data_card__headers--days"
            :style="day.name==actual_day?
                      !scheduleIsInError?'margin-top:-12px !important;background:#FFF':'margin-top:-12px !important;background:#FFF;cursor:not-allowed;' :
                      !scheduleIsInError?'': 'cursor:not-allowed;'"
            @click="!scheduleIsInError?actual_day=day.name:''">
            <span class="data_card__info--label"
                  :style="day.name==actual_day?'font-weight:800;color:black':''">
                  {{ day.name_esp | capitalize }}
            </span>
          </v-flex>
        </v-layout>
    </v-flex>
    <v-flex
      xs12
      style="display:flex; margin: 0px 3% 0px 3%;">
        <v-layout
            row wrap justify-space-between>
          <v-flex  v-for="day in days"
            :key="day.name"
            v-if="day.name!='sunday'||isWeekendActive"
            class="data_card__headers--days--transparency"
            :style="day.name==actual_day?
                      !scheduleIsInError?'margin-top:-12px !important;background:#FFF':'margin-top:-12px !important;background:#FFF;cursor:not-allowed;' :
                      !scheduleIsInError?'': 'cursor:not-allowed;'"
            @click="!scheduleIsInError?actual_day=day.name:''">
          </v-flex>
        </v-layout>
    </v-flex>


    <section class="trainers__create_container data_card__headers--days--panel" >
      <v-layout row wrap>
        <v-flex xs12>
          <v-flex
            xs12 >
            <v-layout row wrap style="justify-content:space-evenly">
              <v-flex xs3>
                <span class="data_card__info--label--hours">Apertura</span>
                <vue-timepicker :class="!errorOpening?'data_card__info--select--time':'data_card__info--select--time--error'"
                    style="margin-left:0 !important"
                    format="hh:mm a"
                    placeholder="Apertura"
                    :hour-range="[startRange]"
                    :minute-range="[startMinutesRange]"
                    :minute-interval="5"
                    auto-scroll
                    close-on-complete
                    input-width="95%"
                    v-model="timeBoxes[actual_day].begin"
                    @input="checkOpening()"
                    hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                    hide-clear-button></vue-timepicker>
              </v-flex>
              <v-flex xs3>
                <span class="data_card__info--label--hours">Cierre</span>
                <vue-timepicker :class="!errorEnding?'data_card__info--select--time':'data_card__info--select--time--error'"
                    style="margin-left:0 !important;"
                    format="hh:mm a"
                    placeholder="Cierre"
                    :minute-interval="5"
                    :minute-range="[endMinutesRange]"
                    auto-scroll
                    close-on-complete
                    input-width="95%"
                    v-model="timeBoxes[actual_day].end"
                    :hour-range="[endRange]"
                    hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                    @change="checkEnding()"
                    hide-clear-button></vue-timepicker>
              </v-flex>
              <v-flex xs1>
                <span class="data_card__info--label--hours">Cupos</span>
                <input
                  :class="!spacesInError?'data_card__info--input--number':'data_card__info--input--number--error'"
                  type="number"
                  name="nationality_code"
                  @keypress="isNumberValid($event)"
                  @blur="isFinalNumberValid($event,days[actual_day])"
                  v-model="days[actual_day].max_spaces"
                  @input="reviewSpaces()"
                >
              </v-flex>
              <v-flex xs2>
                <span class="data_card__info--label--hours" style="white-space:nowrap">Tiempo estadía:</span>
                <vue-timepicker class="data_card__info--select--time"
                    format="H h mm"
                    placeholder="Tiempo estadía"
                    :hour-range="[maxTimeStay.hh]"
                    :minute-range="[[maxTimeStay.mm,maxMM]]"
                    :minute-interval="5"
                    input-width="95%"
                    v-model="timeBoxes[actual_day].stay_time"
                    close-on-complete
                    hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                    hide-clear-button
                    @change="setNewSpaces()"
                    :disabled="days[actual_day].max_spaces == 0"
                    ></vue-timepicker>
              </v-flex>
              <v-flex xs2>
                <span class="data_card__info--label--hours">Reservas cada:</span>
                <vue-timepicker class="data_card__info--select--time"
                    format="H h mm"
                    placeholder="Frecuencia"
                    :hour-range="[0,bookEvery.hh]"
                    :minute-range="[0,[bookMM,bookEvery.mm]]"
                    :minute-interval="5"
                    input-width="95%"
                    v-model="timeBoxes[actual_day].frequency"
                    close-on-complete
                    hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                    hide-clear-button
                    :disabled="days[actual_day].max_spaces == 0"
                    @change="setNewSpaces()"></vue-timepicker>
                  <div class="data_card__create_button--info--booking"
                    :style="validate_quota?'background-color:#FFCA00;color:#000000;':''"
                    >
                    <b style="text-align: center;">{{days[actual_day].spaces_per_booking}} personas por turno</b>
                  </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-flex>
        <v-flex
            xs12 >
            <v-layout row wrap style="justify-content:space-evenly">
              <v-flex xs6>
                <p v-if="time_zone !== timeZoneLocal"
                  style="color:rgb(255, 134, 0);margin-top: 10px;font-size:14px;font-weight:500;"
                >Los horarios serán los correspondientes a la hora de {{ location_time_zone }}, {{ country }} ( GMT{{gtm}} )*</p>
              </v-flex>
              <v-flex xs3>
                <div class="data_card__create_button--info--data__data_connector" >
                </div>
                <div
                  class="data_card__create_button--info--data">
                <p>El máximo de personas en tu sublocación es de <b>{{days[actual_day].max_spaces}} personas</b> </p>
                </div>
              </v-flex>
              <v-flex xs2></v-flex>
            </v-layout>
        </v-flex>
      </v-layout>
      <!-- Inactive times section -->
      <v-layout>
        <div class="offer_elements__condition--inactive_time_container">
          <div class="offer_elements__condition--requirement" v-for="(inactive_time, index) in days[actual_day].inactive_times" :key="index">
            <v-flex xs12>
              <span class="data_card__info--label--hours">Hora Inicio</span>
              <vue-timepicker :class="!inactive_time.errorStart?'data_card__info--select--time':'data_card__info--select--time--error'"
              style="margin-left:0 !important"
              format="hh:mm a"
              placeholder="Inicio Inactividad"
              :hour-range="[startRange]"
              :minute-interval="5"
              auto-scroll
              close-on-complete
              input-width="95%"
              v-model="inactive_time.start_time"
              @change="validateInactiveTimes()"
              hour-label="Horas" minute-label="mins" apm-label="AM/PM"
              hide-clear-button></vue-timepicker>

              <v-flex xs12>
                <span class="data_card__info--label--hours">Hora Fin</span>
                <vue-timepicker :class="!inactive_time.errorEnd?'data_card__info--select--time':'data_card__info--select--time--error'"
                    style="margin-left:0 !important;"
                    format="hh:mm a"
                    placeholder="Fin Inactividad"
                    :minute-interval="5"
                    auto-scroll
                    close-on-complete
                    input-width="95%"
                    v-model="inactive_time.end_time"
                    :hour-range="[endRange]"
                    hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                    @change="validateInactiveTimes()"
                    hide-clear-button></vue-timepicker>
              </v-flex>
            </v-flex>
            <v-hover style="margin-left: auto; margin-right: auto; margin-top: 10px;" title="Eliminar tiempo inactivo">
              <button @click="removeInactiveTime(actual_day ,index)" slot-scope="{ hover }" :class="hover?'offer_elements__interaction--hover_delete':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_gray">
                <div class="offer_elements__button--delete_requirement " :class="hover?'offer_elements__interaction--hover_delete_background':''">
                  <p>x</p>
                </div>
              </button>
            </v-hover>
          </div>
          <v-flex xs12>
            <p class="agreement__text--small_gray ">Añadir Tiempo Inactivo</p>
            <div class="offer_elements__condition--add_container">
              <v-hover>
                  <button @click="addInactiveTime(actual_day)" slot-scope="{ hover }" :class="hover?'accessIndex__interaction--hover_add':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_blue">
                    <p>+</p>
                  </button>
              </v-hover>
            </div>
          </v-flex >
        </div>
      </v-layout>
      <!-- end inactive times section -->
    </section>
    <div
      :class="formIsInError?'data_card__create_button--solid--error':'data_card__create_button--solid'"
      @click="formIsInError?'':createLocation()">
      Crear sublocación
    </div>
<!--     <div>
      <h1>Dias</h1>
      <p>days {{ this.days }}</p>
    </div> -->
  </article>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  data(){
    return{
      locations: [],
      sublocation: {
        attributes:{
          location_id:0,
          name: '',
          // email: '',
          // mobile: ''
        }
      },
      actual_day:"monday",
      errorEnding:false,
      errorOpening:false,
      charged: false,
      originalLocation:{
        id:0,
        name:'Sublocation'
      } ,
      days: {
        monday:     {name: 'monday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'lunes',
                     inactive_times: []
                    },
        tuesday:    {name: 'tuesday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'martes',
                     inactive_times: []
                    },
        wednesday:  {name: 'wednesday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'miércoles',
                     inactive_times: []
                    },
        thursday:   {name: 'thursday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'jueves',
                     inactive_times: []
                    },
        friday:     {name: 'friday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'viernes',
                     inactive_times: []
                    },
        saturday:   {name: 'saturday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'sábado',
                     inactive_times: []
                    },
        sunday:     {name: 'sunday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0:00",
                     stay_time:"0:00",
                     type:'string',
                     name_esp: 'domingo',
                     inactive_times: []
                    }
      },
      timeBoxes:{
        monday:     {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        tuesday:    {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        wednesday:  {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        thursday:   {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        friday:     {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        saturday:   {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        sunday:     {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    }
      },
      maximum_spaces:{
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday:0,
      saturday:0,
      sunday:0
      },
      spacesInError:false,
      validate_quota: false,
      country: '',
      time_zone: '',
      location_time_zone: '',
      gtm: '',
      max_hh_minutes: 0,
      book_hh_minutes: 0,
      max_mm: 0,
      book_mm: 0,
      time_stay: 0,
      book_every: 0,
      book_every_minutes: 0,
      invalid_inactive_times: false
    }
  },
  components: { VueTimepicker },
  computed:{
    formIsInError(){
      var ans=false
      if(this.scheduleIsInError||this.sublocation.attributes.name.length==0||this.spacesInError||this.invalid_inactive_times){
        ans=true
      }
      return ans
    },
    scheduleIsInError(){
      var ans=false
      if(this.errorOpening||this.errorEnding||this.spacesInError){
        ans=true
      }
      return ans
    },
    isWeekendActive(){
      var self=this;
      return this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule.works_on_sundays
    },
    startRange(){
      var self=this;
      let data= this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      return [data.beginning.hour, data.ending.hour]
    },
    endRange(){
      var self=this;
      let data= this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      let beg=data.beginning.hour;
      let myData= this.timeBoxes[this.actual_day]
      let bMyData= Number(this.convertDaytimeFormatToHour(myData.begin).split(":")[0])

      if(bMyData>beg){
        beg=bMyData;
      }
      let end=data.ending.hour

      return [beg,end]
    },
    startMinutesRange(){
      var self=this;
      let mins=[0,60]
      let data= this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      let myData= this.timeBoxes[this.actual_day]
      let arr=this.convertDaytimeFormatToHour(myData.begin).split(":")
      let beg=Number(arr[0])
      if(beg==data.beginning.hour){
        mins=[data.beginning.minute,60]
      }
      if(beg==data.ending.hour){
        mins=[mins[0],data.ending.minute]
      }
      return mins;
    },
    endMinutesRange(){
      var self=this;
      let mins=[0,60]
      let data= this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      let myData= this.timeBoxes[this.actual_day]
      let arr=this.convertDaytimeFormatToHour(myData.end).split(":")
      let arr2=this.convertDaytimeFormatToHour(myData.begin).split(":")
      let end=Number(arr[0])
      if(end==data.ending.hour){
        mins=[0,data.ending.minute]
      }
      if(end==Number(arr2[0])){
        mins=[Number(arr2[1]),mins[1]]
      }
      return mins;
    },
    bookEvery(){
      let hh = 0
      let mm = 0
      let t = this.timeBoxes[this.actual_day].stay_time
      let f = this.timeBoxes[this.actual_day].frequency
      let c = this.days[this.actual_day].max_spaces
      let hh_t = parseInt(t.substring(0,t.indexOf('h') - 1))
      let mm_t = parseInt(t.substring(t.indexOf('h') + 2, t.length))
      let hh_f = parseInt(f.substring(0,f.indexOf('h') - 1))
      let mm_f = parseInt(f.substring(f.indexOf('h') + 2, f.length))
      this.time_stay = hh_t
      /* if (hh_f > 0 || mm_f > 0) {  */
        let total_stay_time = 0
        hh_t > 0 ? total_stay_time = ((hh_t * 60) + mm_t) : total_stay_time = mm_t
        let min_time = (total_stay_time / c)
          if (total_stay_time >= 60){
            hh = min_time / 60
            let minutes_decimal =  (hh - Math.floor(hh))
            mm = Math.floor((minutes_decimal * 60))
            this.book_mm = mm
            hh = Math.floor(hh)
          } else {
            mm = mm_t
            /* mm = min_time  */
            this.book_mm = mm
          }
        this.book_hh_minutes = ( hh * 60 ) + mm
      /* } */
      return { hh: [hh,23], mm: 55 }
    },
    maxTimeStay(){
      let hh = 23
      let mm = 55
      let t = this.timeBoxes[this.actual_day].stay_time
      let f = this.timeBoxes[this.actual_day].frequency
      let c = this.days[this.actual_day].max_spaces
      let hh_f = parseInt(f.substring(0,f.indexOf('h') - 1))
      let mm_f = parseInt(f.substring(f.indexOf('h') + 2, f.length))
      this.book_every = hh_f
      this.book_every_minutes = mm_f
      if (hh_f > 0 || mm_f > 0) {
        let total_frequency = 0
        hh_f > 0 ? total_frequency = ((hh_f * 60) + mm_f) : total_frequency = mm_f
        let min_time = (total_frequency * c)
        if (min_time >= 60){
          hh = min_time  / 60
          let minutes_decimal =  (hh - Math.floor(hh))
          mm = Math.floor((minutes_decimal * 60))
          this.max_mm = mm;
          hh = Math.floor(hh)
        } else {
          hh = 0
          mm = min_time
          this.max_mm = mm
        }
        this.max_hh_minutes = ( hh * 60 ) + mm
        return { hh: [0,hh], mm: 0 }
      }
      return { hh: [0,hh], mm: 0 }
    },
    bookMM(){
      const minutes = this.book_hh_minutes
      const current_minutes = (this.book_every * 60)
      /* if (minutes < 60 ) return this.book_mm */
      return  minutes - current_minutes
    },
    maxMM(){
      const minutes = this.max_hh_minutes
      if (this.book_every === 0 && this.book_every_minutes === 0) return 60
      if (minutes < 60 ) return this.max_mm
      const current_minutes = (this.time_stay * 60)
      return minutes - current_minutes
    },
    timeZoneLocal: function(){
      let resolvedOptions = Intl.DateTimeFormat().resolvedOptions()
      return resolvedOptions.timeZone
    },
  },
  watch:{
    schedule_url(){
      // cl schedule_url
      this.schedule_url_change = true;
    },
    manager_url(){
      // cl manager_url
      if(this.manager_url != ''){
        this.manager_url_change = true;
      }
    },
  },
  mounted(){
    var path = this.$route.params.id
    var self=this;

    try {
      this.$http.get('locations_schedule',{
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
      })
      .then(function(response){
        console.log('===locations_schedule=== ', response)
        this.locations = response.body.locations
        let myOriginalLocation=this.locations.find(element => element.id == path)
        this.originalLocation.id= myOriginalLocation.id
        this.originalLocation.name=myOriginalLocation.name
        this.sublocation.attributes.location_id=myOriginalLocation.id
        var myLoc=this.locations.find(element => element.id == self.sublocation.attributes.location_id)
        console.log("----------------------");
        console.log(myLoc);
        console.log(myLoc.schedule);
        console.log(myLoc.occupied_spaces);
        Object.keys(this.maximum_spaces).forEach(x=>this.maximum_spaces[x]= (myLoc.schedule && myLoc.occupied_spaces) && (myLoc.schedule[x] && myLoc.occupied_spaces[x]) ? myLoc.schedule[x].max_spaces-myLoc.occupied_spaces[x] : 0)
          // this.timeBoxes[new_schedules[i][0]].stay_time=this.convertDurationToStyleFormat(this.days[new_schedules[i][0]].stay_time)
          // var max=this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[new_schedules[i][0]].max_spaces
          // var used=this.locations.find(element => element.id == self.sublocation.attributes.location_id).occupied_spaces[new_schedules[i][0]]
          // let myTotalDaySpaces=max-used+Number(this.days[new_schedules[i][0]].max_spaces)
          // this.maximum_spaces[new_schedules[i][0]]=myTotalDaySpaces
       this.charged = true;
       var myDays = myLoc.get_data
       this.country = myLoc.country
       this.time_zone = myLoc.time_zone
       /* console.log('time_zone  ', this.time_zone)  */
       this.location_time_zone = myLoc.time_zone.substring(myLoc.time_zone.indexOf('/') + 1,myLoc.time_zone.length).replace(/[_]/g,' ')
       this.gtm = myLoc.gtm.substring(0,3) + ":" + myLoc.gtm.substring(3,5)/* .replace(/[0]/g,'')  */
       var new_schedules = Object.entries(myDays)
      for (var i = 0; i < new_schedules.length; i++) {
        try {
          let hh_1 = ''
          let mm_1 = ''
          let h1 = String(new_schedules[i][1].beginning.hour)
          h1.length === 1 ? hh_1 = '0' + h1 : hh_1 = h1
          let m1 = String(new_schedules[i][1].beginning.minute)
          m1.length === 1 ? mm_1 = '0' + m1 : mm_1 = m1
          let beginning = hh_1 + ":" + mm_1
          let hh_2 = ''
          let mm_2 = ''
          let h2 = String(new_schedules[i][1].ending.hour)
          h2.length === 1 ? hh_2 = '0' + h2 : hh_2 = h2
          let m2 = String(new_schedules[i][1].ending.minute)
          m2.length === 1 ? mm_2 = '0' + m2 : mm_2 = m2
          let ending = hh_2 + ":" + mm_2
          this.days[new_schedules[i][0]].begin = beginning
          this.days[new_schedules[i][0]].end = ending
          this.timeBoxes[new_schedules[i][0]].begin=this.convertHourToStyleFormat(this.days[new_schedules[i][0]].begin)
          this.timeBoxes[new_schedules[i][0]].end=this.convertHourToStyleFormat(this.days[new_schedules[i][0]].end)
        } catch (error) {

        }
      }
      this.setNewSpaces();
      this.charged = true

      }, function(response){
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
      } catch (e) {
        alert(e.message)
      }
  },
  methods:{
    changeLocation(){
      console.log("AHAH")
    },
    checkOpening(){
      let times=this.timeBoxes[this.actual_day]
      let begin= this.convertDaytimeFormatToHour(times.begin)
      if(begin.includes("NaN")){
        this.errorOpening=true;
      }else{
        this.errorOpening=false;
      }
      console.log("ENTER")
      this.reviewTimes()
    },
    checkEnding(){
      let times=this.timeBoxes[this.actual_day]
      let end= this.convertDaytimeFormatToHour(times.end)
      if(end.includes("NaN")){
        this.errorEnding=true;
      }else{
        this.errorEnding=false;
      }

      this.reviewTimes()
    },
    reviewTimes(){
      let times=this.timeBoxes[this.actual_day]
      var self= this
      var myData={}

      var myLocation=this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      myData.begin= this.convertDaytimeFormatToHour(times.begin)
      myData.end= this.convertDaytimeFormatToHour(times.end)

      let beginArr=myData.begin.toString().split(":")
      let endArr=myData.end.toString().split(":")

      if(myData.begin.includes("NaN") ||
         Number(beginArr[0])<myLocation.beginning.hour ||
        (Number(beginArr[0])==myLocation.beginning.hour && Number(beginArr[1])<myLocation.beginning.minute)){
        myData.begin= myLocation.beginning.hour.toString().padStart(2,"0")+":"+myLocation.beginning.minute.toString().padStart(2,"0");
      }
      if(myData.end.includes("NaN") ||
         Number(endArr[0])>myLocation.ending.hour ||
        (Number(endArr[0])==myLocation.ending.hour && Number(endArr[1])>myLocation.ending.minute)){
        myData.end= myLocation.ending.hour.toString().padStart(2,"0")+":"+myLocation.ending.minute.toString().padStart(2,"0");
      }

      if(
         Number(beginArr[0])>myLocation.ending.hour ||
        (Number(beginArr[0])==myLocation.ending.hour && Number(beginArr[1])>myLocation.ending.minute)){
         myData.begin= myLocation.ending.hour.toString().padStart(2,"0")+":"+myLocation.ending.minute.toString().padStart(2,"0");
      }
      if(
         Number(endArr[0])<myLocation.beginning.hour ||
        (Number(endArr[0])==myLocation.beginning.hour && Number(endArr[1])<myLocation.beginning.minute)){
        myData.end= myData.begin
      }

      if(myData.begin>myData.end){
        myData.end=myData.begin
      }
      this.timeBoxes[this.actual_day].begin=this.convertHourToStyleFormat(myData.begin)
      this.timeBoxes[this.actual_day].end=this.convertHourToStyleFormat(myData.end)
      this.setNewSpaces()
    },
    checkSchedule () {
      var vm = this
      Object.keys(vm.days).forEach(function (key) {
        if (vm.days[key].begin == '' || vm.days[key].end == '') {
          delete vm.days[key]
        }
      });
    },
    isNumberValid(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();;
        }else {
            return true;
        }
    },
    isFinalNumberValid(myData,day){
        if(myData.target.value.length==0){
          day.max_spaces=0;
        }else{
          if(day.max_spaces.toString()[0]=="0"&&day.max_spaces.length>0){
            day.max_spaces= Number(day.max_spaces.replace(/^0+/, ''));
          }
        }
    },

    reviewSpaces(){
      let data=this.days[this.actual_day]
      if(data.max_spaces>this.maximum_spaces[this.actual_day] ||data.max_spaces<0){
        this.spacesInError=true;
      }else{
        this.spacesInError=false;
      }
      this.setNewSpaces();
    },

    setNewSpaces(){
      let data=this.timeBoxes[this.actual_day]
      var myData={};
      myData.frequency=this.convertDurationFormat(data.frequency)
      myData.stay_time=this.convertDurationFormat(data.stay_time)
      myData.begin= this.convertDaytimeFormatToHour(data.begin)
      myData.end= this.convertDaytimeFormatToHour(data.end)
      myData.max_spaces=this.days[this.actual_day].max_spaces
      this.days[this.actual_day].spaces_per_booking=this.getConcurrentClassTimes(myData)
      this.getConcurrentClassTimes(myData) === 0 && this.days[this.actual_day].max_spaces > 0 ? this.validate_quota = true : this.validate_quota = false
    },
    getConcurrentClassTimes(data){
      var concurrentBookings=this.recurrentScheduleCounter(data.begin,
                                    this.addHours(data.begin,data.stay_time),
                                    data.end,data.begin,data.frequency,
                                    data.stay_time)
      let ans=data.max_spaces
      if(concurrentBookings>1){
        ans=Math.floor(data.max_spaces/concurrentBookings)
      }else if(concurrentBookings==0){
        ans=0
      }
      return ans;
    },
    recurrentScheduleCounter(firstHour,firstEnd,endHour,hour,freq, period){
      if(
         (!this.firstIsGreaterThanSecond(firstEnd,hour) && firstHour!=hour) ||
         this.firstIsGreaterThanSecond(this.addHours(hour,period),endHour) ||
         this.firstIsGreaterThanSecond(firstHour,hour) || period=="0:00"
        ){
        return 0
      }else if(freq=="0:00"){
        return 1
      }
      else{
        return 1+this.recurrentScheduleCounter( firstHour, firstEnd, endHour,
                                                this.addHours(hour,freq),
                                                freq, period
                                              )
      }
    },

    createLocation(){
      // this.checkSchedule()
      this.setDaysWithNewTimes();
      this.sublocation.attributes.sublocation_schedule_attributes = this.days

      try {
        this.$http.post('sublocations/', {data: this.encrypt(this.sublocation).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          console.log('=== New_sublocations === ', response)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          this.$router.push({name: 'sublocations', params: {id: response.data.data.attributes.location_id}})
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    convertHourToStyleFormat(hour){
      var arr=hour.split(":")
      var amOrPm="am"
      if(arr[0]>=12){
        amOrPm="pm"
        if(arr[0]>12){
          arr[0]= Number(arr[0])%12
        }
      }else if(arr[0]==0){
        arr[0]=12
      }
      if(Number(arr[0])<10){
        arr[0]="0"+Number(arr[0]).toString()
      }
      return arr[0]+":"+arr[1]+" "+amOrPm;
    },
    convertDurationToStyleFormat(hour){
      var arr=hour.split(":")
      return arr[0]+" h "+arr[1].toString().padStart(2,"0");
    },
    setDaysWithNewTimes(){
      var myConversion=function convertStyleFormatToHour(hour){
        var arr=hour.split(":")
        let hours=Number(arr[0])
        let secondArr=arr[1].split(" ")
        var minutes=secondArr[0]
        var amOrPm=secondArr[1]
        var finalHour=[hours,minutes]

        if(amOrPm=="pm" && hours!=12){
          finalHour[0]= (Number(hours)+12)%24
        }else if(hours==12 && amOrPm=="am" ){
          finalHour[0]=0
        }
        return finalHour[0].toString().padStart(2,"0")+":"+finalHour[1].toString().padStart(2,"0");
      }
      var myHourConversion= function convertFormatToSend(time){
        let arr=time.split(" h ")
        return arr[0]+":"+arr[1].toString().padStart(2,"0");
      }
      for(var key in this.timeBoxes){
        this.days[key].begin=myConversion(this.timeBoxes[key].begin);
        this.days[key].end=myConversion(this.timeBoxes[key].end);
        this.days[key].frequency=myHourConversion(this.timeBoxes[key].frequency);
        this.days[key].stay_time=myHourConversion(this.timeBoxes[key].stay_time);

        this.days[key].inactive_times.forEach((value, index) => {
          value.start_time = myConversion(value.start_time);
          value.end_time = myConversion(value.end_time);
        });
      }
    },
    addInactiveTime(day_name){
      var inactiveTime = {
        weekday: day_name,
        start_time: this.timeBoxes[day_name].begin,
        end_time: this.timeBoxes[day_name].begin,
        errorStart: false,
        errorEnd: false
      }
      this.days[day_name].inactive_times.push(inactiveTime);
    },
    removeInactiveTime(day_name, index) {
      this.days[day_name].inactive_times.splice(index, 1)
      this.validateInactiveTimes()
    },
    validateInactiveTimes(){
      this.days[this.actual_day].inactive_times.forEach((value, i) => {
        this.inactiveTimeValidations(i)
      });
    },
    inactiveTimeValidations(index){
      let times=this.days[this.actual_day].inactive_times[index]
      var self= this
      var myData={}

      let beginInRange = 0
      let endInRange = 0

      var myLocation=this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      myData.begin= this.convertDaytimeFormatToHour(times.start_time)
      myData.end= this.convertDaytimeFormatToHour(times.end_time)

      let beginArr=myData.begin.toString().split(":")
      let endArr=myData.end.toString().split(":")

      if(myData.begin.includes("NaN") ||
         Number(beginArr[0])<myLocation.beginning.hour ||
        (Number(beginArr[0])==myLocation.beginning.hour && Number(beginArr[1])<myLocation.beginning.minute)){
        myData.begin= myLocation.beginning.hour.toString().padStart(2,"0")+":"+myLocation.beginning.minute.toString().padStart(2,"0");
      }
      if(myData.end.includes("NaN") ||
         Number(endArr[0])>myLocation.ending.hour ||
        (Number(endArr[0])==myLocation.ending.hour && Number(endArr[1])>myLocation.ending.minute)){
        myData.end= myLocation.ending.hour.toString().padStart(2,"0")+":"+myLocation.ending.minute.toString().padStart(2,"0");
      }
      if(
         Number(beginArr[0])>myLocation.ending.hour ||
        (Number(beginArr[0])==myLocation.ending.hour && Number(beginArr[1])>myLocation.ending.minute)){
         myData.begin= myLocation.ending.hour.toString().padStart(2,"0")+":"+myLocation.ending.minute.toString().padStart(2,"0");
      }
      if(
         Number(endArr[0])<myLocation.beginning.hour ||
        (Number(endArr[0])==myLocation.beginning.hour && Number(endArr[1])<myLocation.beginning.minute)){
        myData.end= myData.begin
      }

      if(myData.begin>myData.end){
        myData.end=myData.begin
      }

      this.days[this.actual_day].inactive_times.forEach((value, i) => {
        if(index != i){
          var valueBegin = this.convertDaytimeFormatToHour(value.start_time)
          var compareBegin = valueBegin.toString().split(":")
          var valueEnd = this.convertDaytimeFormatToHour(value.end_time)
          var compareEnd = valueEnd.toString().split(":")
          if(Number(beginArr[0]) > Number(compareBegin[0]) && Number(beginArr[0]) < Number(compareEnd[0]) ||
          (Number(beginArr[0]) == Number(compareBegin[0]) && Number(beginArr[1]) >= Number(compareBegin[1])) && (Number(beginArr[0]) < Number(compareEnd[0])) ||
          (Number(beginArr[0]) == Number(compareEnd[0]) && Number(beginArr[1]) <= Number(compareEnd[1])) ){
            beginInRange++
          }
          if(Number(endArr[0]) > Number(compareBegin[0]) && Number(endArr[0]) < Number(compareEnd[0]) ||
          (Number(endArr[0]) == Number(compareBegin[0]) && Number(endArr[1]) >= Number(compareBegin[1])) && (Number(endArr[0]) <= Number(compareEnd[0]) && Number(endArr[1]) <= Number(compareEnd[1])) ||
          (Number(endArr[0]) == Number(compareBegin[0]) && Number(endArr[1]) >= Number(compareBegin[1])) && Number(endArr[0]) <= Number(compareEnd[0]) ){
            endInRange++
          }
          if(Number(beginArr[0]) < Number(compareBegin[0]) && Number(endArr[0]) > Number(compareEnd[0]) ||
          (Number(beginArr[0]) <= Number(compareBegin[0]) && Number(beginArr[1]) <= Number(compareBegin[1]) ) && (Number(endArr[0]) >= Number(compareEnd[0]) && Number(endArr[1]) >= Number(compareEnd[1])) ||
          (Number(endArr[0]) >= Number(compareBegin[0]) && Number(endArr[1]) >= Number(compareBegin[1]) ) && (Number(endArr[0]) <= Number(compareEnd[0]) && Number(endArr[1]) <= Number(compareEnd[1])) ||
          (Number(beginArr[0]) <= Number(compareBegin[0]) && Number(beginArr[1]) <= Number(compareBegin[1]) ) && Number(endArr[0]) > Number(compareEnd[0]) ){
            beginInRange++
            endInRange++
          }
        }
      });

      if(beginInRange > 0 || endInRange > 0){
        if(beginInRange > 0){
          this.days[this.actual_day].inactive_times[index].errorStart = true
        }else{
          this.days[this.actual_day].inactive_times[index].errorStart = false
        }
        if(endInRange > 0){
          this.days[this.actual_day].inactive_times[index].errorEnd = true
        }else{
          this.days[this.actual_day].inactive_times[index].errorEnd = false
        }
        this.invalid_inactive_times = true
      }else{
        this.invalid_inactive_times = false
        this.days[this.actual_day].inactive_times[index].errorStart = false
        this.days[this.actual_day].inactive_times[index].errorEnd = false
      }

      this.days[this.actual_day].inactive_times[index].start_time=this.convertHourToStyleFormat(myData.begin)
      this.days[this.actual_day].inactive_times[index].end_time=this.convertHourToStyleFormat(myData.end)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/locations/sublocations/New_sublocation.vue